import CustomerAccountsPaymentPanel from './CustomerAccountsPaymentPanel'
import { useCustomerAccountPayment } from './useCustomerAccountPayment'
import { Button, Card, CardContent, Grid } from '@mui/material'
import { useTranslation } from 'react-i18next'
import usePaymentContext from '../../hook/usePaymentContext'

const CustomerAccountPaymentForm = () => {
    const { t } = useTranslation()
    const {
        paymentAccounts,
        onSelectCustomerAccount,
        onCloseAccountDialog,
        orderCustomerID,
        customerList,
        selectedCustomerAccount,
        loadingCustomerPaymentAccount,
    } = usePaymentContext()

    const {
        onAssignToPayment,
        selectedCustomer: popupSelectedCustomer,
        popupSelectCustomerId,
        setPopupSelectCustomerID,
        customerAccounts,
    } = useCustomerAccountPayment({
        selectedCustomerId:
            selectedCustomerAccount?.customer?.customerID ?? orderCustomerID,
        customerList,
        paymentAccounts,
        onSelectCustomerAccount,
        onCloseAccountDialog,
    })

    return (
        <Card variant="outlined">
            <CardContent>
                <Grid container direction={'column'}>
                    <Grid item>
                        <CustomerAccountsPaymentPanel
                            customerAccounts={customerAccounts}
                            selectedCustomerId={popupSelectCustomerId}
                            onSelectCustomer={setPopupSelectCustomerID}
                            onAssignToPayment={onAssignToPayment}
                            isLoading={loadingCustomerPaymentAccount}
                        />
                    </Grid>
                    <Grid item textAlign={'end'} pt={2}>
                        <Button
                            disabled={!popupSelectedCustomer}
                            className="textUpper"
                            color="primary"
                            onClick={() =>
                                onAssignToPayment(popupSelectCustomerId)
                            }
                        >
                            {t('quick_sell.button.use_for_payment')}
                        </Button>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

export default CustomerAccountPaymentForm
